import React, { useState } from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';
import { useParams } from 'react-router-dom';
import { getEntityDetails } from '../../../../services/ApiServices';

export function TradingDirectResponseMappingCustomNewPage(): React.ReactElement {
  const [state] = useState<ITradingDirectResponseMapping>({ Id: '' });
  const currentSecurity = useSecurity('Trading', 'DirectResponseMapping');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(
        [
          'Areas/Trading/Scripts/Resources/en/res.DirectResponseMapping.en.js',
          'Areas/Trading/Scripts/Resources/en/Types.en.js',
          'Areas/Trading/Scripts/Enums.js',
          'Areas/Trading/Scripts/DirectResponseMapping/View.custom.js',
        ],
        'initNew',
        { viewmodel: state, canEdit: true, canCreate: true, canRemove: true },
      );
    }
  }, []);
  return (
    <div className="container-fluid">
      <section id="patron">
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="DirectResponseMapping" className="controls-container default block">
              <h3>
                Create a New <b>Direct Response Mappings</b>
              </h3>
              <p>Please fill in the fields, once completed click on Save to proceed with the creation:</p>
              <form id="form" action="" className="content-view row">
                <div className="col-md-2">
                  <label>Code</label>
                  <input
                    id="DirectResponseMappingCode"
                    max="20"
                    name="Code"
                    type="text"
                    defaultValue={state.Code}
                    className="shortcontrol disabled k-input k-input-solid k-textbox"
                    readOnly
                    disabled
                    placeholder="AUTO-CODE"
                  />
                </div>
                <div className="col-md-2">
                  <label id="DirectResponseMappingLabelBlockedCode">Blocked</label>
                  <input
                    id="DirectResponseMappingCheckBlockedCode"
                    defaultChecked
                    name="DirectResponseMappingCheckBlockedCode"
                    type="checkbox"
                  />
                </div>
                <div className="clear"></div>
                <div className="col-md-4">
                  <label htmlFor="Alias">Alias</label>
                  <input
                    required
                    data-required-msg="Alias is required"
                    id="DirectResponseMappingAlias"
                    name="Alias"
                    type="text"
                    defaultValue={state.Alias}
                    className="k-input k-input-solid k-textbox"
                  />
                </div>
                <div className="col-md-4 shortcontrol-container combobox ">
                  <label htmlFor="BoundedContext">Bounded Context</label>
                  <select
                    className=""
                    id="DirectResponseMappingBoundedContext"
                    name="BoundedContext"
                    required
                    data-required-msg="Bounded Context is required"
                  ></select>
                </div>
                <div className="col-md-4 shortcontrol-container combobox ">
                  <label htmlFor="Entity">Entity</label>
                  <select
                    className=""
                    id="DirectResponseMappingEntity"
                    name="Entity"
                    required
                    data-required-msg="Entity is required"
                  ></select>
                </div>
                <div className="col-md-4 shortcontrol-container combobox ">
                  <label htmlFor="EntityName">Entity Name</label>
                  <select
                    className=""
                    id="DirectResponseMappingEntityName"
                    name="EntityName"
                    required
                    data-required-msg="Entity Name is required"
                  ></select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="SourceReference">Source Reference</label>
                  <input
                    id="DirectResponseMappingSourceReference"
                    max="60"
                    name="SourceReference"
                    type="text"
                    defaultValue={state.SourceReference}
                    className="shortcontrol k-input k-input-solid k-textbox"
                    placeholder="SOURCE-REFERENCE"
                  />
                </div>
              </form>
              <section className="button-toolbar" id="ToolbarDirectResponseMapping">
                <div className="left">
                  <button
                    id="cancelDirectResponseMappingButton"
                    type="button"
                    className="k-button button"
                    title="Cancel"
                  >
                    Cancel
                  </button>
                </div>
                <div className="right">
                  <button id="saveDirectResponseMappingButton" type="button" className="k-button button" title="Save">
                    Save
                  </button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}

export interface ITradingDirectResponseMapping {
  BoundedContext?: string;
  Alias?: string;
  Entity?: string;
  EntityName?: string;
  Code?: string;
  Display?: string;
  EntityStatus?: number;
  SourceReference?: string;
  Id: string;
  InactiveFrom?: Date;
}

export function TradingDirectResponseMappingCustomDetailPage(): React.ReactElement {
  const { id } = useParams();
  const [state, setState] = useState<ITradingDirectResponseMapping>({ Id: '' });
  const currentSecurity = useSecurity('Trading', 'DirectResponseMapping');
  React.useEffect(() => {
    if (state.Id == '' && currentSecurity.checkAccess()) {
      getEntityDetails('Trading', 'DirectResponseMapping', id).then((result) => {
        setState(result.Value[0] as ITradingDirectResponseMapping);
        appendScriptsCallback(
          [
            'Areas/Trading/Scripts/Resources/en/res.DirectResponseMapping.en.js',
            'Areas/Trading/Scripts/Resources/en/Types.en.js',
            'Areas/Trading/Scripts/Enums.js',
            'Areas/Trading/Scripts/DirectResponseMapping/View.custom.js',
          ],
          'initDetail',
          { viewmodel: result.Value[0], canEdit: true, canCreate: true, canRemove: true, id: id },
        );
      });
    }
  }, []);
  window['reloadTradingDirectResponseMappingState'] = (data) => {
    setState(data.Value[0] as ITradingDirectResponseMapping);
  };
  return (
    <div className="container-fluid">
      <section id="patron" style={{ display: 'none' }}>
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="DirectResponseMapping" className="controls-container default block">
              <div className="content-label">
                <div className="content-title">
                  <div className="k-content">
                    <h3>
                      Direct Response Mappings: <span>{state.Display}</span>
                      <span
                        id="DirectResponseMappingToggle"
                        className="k-icon k-i-media-manager"
                        style={{ cursor: 'pointer' }}
                      ></span>
                    </h3>
                  </div>
                </div>
                <div className="content-line"></div>
              </div>
              <form id="form" action="" style={{ display: 'none' }} className="content-view row">
                <div className="col-md-2">
                  <label>Code</label>
                  <input
                    id="DirectResponseMappingCode"
                    max="20"
                    name="Code"
                    type="text"
                    defaultValue={state.Code}
                    className="shortcontrol disabled k-input k-input-solid k-textbox"
                    readOnly
                    disabled
                    placeholder="AUTO-CODE"
                  />
                </div>
                <div className="col-md-2">
                  <label id="DirectResponseMappingLabelBlockedCode">Blocked</label>
                  <input
                    id="DirectResponseMappingCheckBlockedCode"
                    defaultChecked
                    name="DirectResponseMappingCheckBlockedCode"
                    type="checkbox"
                  />
                </div>
                <div className="clear"></div>
                <div className="col-md-4">
                  <label htmlFor="Alias">Alias</label>
                  <input
                    required
                    data-required-msg="Alias is required"
                    id="DirectResponseMappingAlias"
                    name="Alias"
                    type="text"
                    defaultValue={state.Alias}
                    className="k-input k-input-solid k-textbox"
                  />
                </div>
                <div className="col-md-4 shortcontrol-container combobox ">
                  <label htmlFor="BoundedContext">Bounded Context</label>
                  <select
                    className=""
                    id="DirectResponseMappingBoundedContext"
                    name="BoundedContext"
                    required
                    data-required-msg="Bounded Context is required"
                    defaultValue={state.BoundedContext}
                  >
                    {state.BoundedContext && <option value={state.BoundedContext}>{state.BoundedContext}</option>}
                  </select>
                </div>
                <div className="col-md-4 shortcontrol-container combobox ">
                  <label htmlFor="Entity">Entity</label>
                  <select
                    className=""
                    id="DirectResponseMappingEntity"
                    name="Entity"
                    required
                    data-required-msg="Entity is required"
                    defaultValue={state.Entity}
                  >
                    {state.Entity && <option value={state.Entity}>{state.Entity}</option>}
                  </select>
                </div>
                <div className="col-md-4 shortcontrol-container combobox ">
                  <label htmlFor="EntityName">Entity Name</label>
                  <select
                    className=""
                    id="DirectResponseMappingEntityName"
                    name="EntityName"
                    required
                    data-required-msg="Entity Name is required"
                    defaultValue={state.EntityName}
                  >
                    {state.EntityName && <option value={state.EntityName}>{state.EntityName}</option>}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="SourceReference">Source Reference</label>
                  <input
                    id="DirectResponseMappingSourceReference"
                    max="60"
                    name="SourceReference"
                    type="text"
                    defaultValue={state.SourceReference}
                    className="shortcontrol k-input k-input-solid k-textbox"
                    placeholder="SOURCE-REFERENCE"
                  />
                </div>
              </form>
              <section className="button-toolbar" style={{ display: 'none' }} id="ToolbarDirectResponseMapping">
                <div className="left">
                  <button
                    id="cancelDirectResponseMappingButton"
                    type="button"
                    className="k-button button"
                    title="Cancel"
                  >
                    Cancel
                  </button>
                </div>
                <div className="right">
                  <button id="saveDirectResponseMappingButton" type="button" className="k-button button" title="Save">
                    Save
                  </button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}
